import createTheme from './createTheme';
import useThemeWithoutDefault from './useThemeWithoutDefault';
export const systemDefaultTheme = createTheme();

function useTheme(defaultTheme = systemDefaultTheme) {
  return useThemeWithoutDefault(defaultTheme);
}

export default useTheme;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/system/esm/useTheme.js
// module id = 422
// module chunks = 0